/** biome-ignore-all lint/a11y/noLabelWithoutControl: <This is a primitive component, there is no input/field associated with it> */
import { Slot } from '@radix-ui/react-slot';
import classNames from 'classnames';
import { type ComponentPropsWithRef, type ElementRef, forwardRef } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const LABEL_ELEMENT_TAG = 'label';

const label = tailwindVariants({
  base: 'block font-medium text-grey-10',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      medium: 'text-14',
      small: 'text-12',
    },
  },
});

export type LabelVariants = VariantProps<typeof label>;

export type LabelProps = ComponentPropsWithRef<typeof LABEL_ELEMENT_TAG> &
  LabelVariants & {
    asChild?: boolean;
  };

export const Label = forwardRef<ElementRef<typeof LABEL_ELEMENT_TAG>, LabelProps>(
  ({ asChild, className, htmlFor, size, ...restOfProps }, forwardedRef) => {
    const Component = asChild ? Slot : LABEL_ELEMENT_TAG;

    return (
      <Component
        className={label({ class: classNames(htmlFor ? 'cursor-pointer' : 'cursor-auto', className), size })}
        htmlFor={htmlFor}
        ref={forwardedRef}
        {...restOfProps}
      />
    );
  },
);

Label.displayName = 'Label';
